import React from "react";
import { Card, Col, Row, Table, Typography, Button } from "antd";
import { PAGINATION } from "../../../admin/_redux/constants";
import { TIME_FORMAT_DATE_TIME } from "../../../app/_redux/constants";
import dayjs from "dayjs";
import _ from "lodash";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import { capitalizeAllProperNouns } from "../../../../../core/helpers/utils";

const { Text } = Typography;
function TripodLogList({
  total,
  loading,
  dataSource,
  param,
  onChangeParam,
  onClickRenew,
  verify_modes,
  sync_states,
  checkin_types
}) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };
  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      width: "3%",
      align: "center"
    },
    {
      dataIndex: "time",
      title: "Ngày giờ",
      width: "8%",
      align: "center",
      render: time =>
        time ? dayjs(time).format(TIME_FORMAT_DATE_TIME) : DEFAULT_VALUE
    },
    {
      dataIndex: "profile_id",
      title: "ID nhân viên",
      width: "8%",
      align: "center",
      render: profile_id => profile_id || DEFAULT_VALUE
    },
    {
      dataIndex: "user",
      title: "Username",
      width: "8%",
      align: "center",
      render: user => _.get(user, "username", DEFAULT_VALUE)
    },
    {
      title: "Tên nhân viên",
      dataIndex: "user",
      width: "8%",
      align: "center",
      render: user => {
        if (!user || !user.fullname) {
          return DEFAULT_VALUE;
        }

        return capitalizeAllProperNouns(user.fullname);
      }
    },
    {
      dataIndex: "station",
      title: "Tên kho",
      width: "10%",
      render: station => {
        return (
          <Text>
            <span style={SNoStyle}>
              {_.get(station, "station_id", DEFAULT_VALUE)}
            </span>
            {" | " + `${_.get(station, "station_name", DEFAULT_VALUE)}`}
          </Text>
        );
      }
    },
    {
      title: "Phòng ban",
      dataIndex: "user",
      width: "8%",
      align: "center",
      render: user => _.get(user, "department", DEFAULT_VALUE)
    },
    {
      dataIndex: "device",
      title: "Tên thiết bị",
      width: "8%",
      align: "center",
      render: device => _.get(device, "name", DEFAULT_VALUE)
    },
    {
      dataIndex: "device_id",
      title: "SN",
      width: "8%",
      align: "center",
      render: device_id => device_id || DEFAULT_VALUE
    },
    {
      title: "IP thiết bị",
      dataIndex: "device_ip",
      width: "8%",
      align: "center",
      render: device_ip => device_ip || DEFAULT_VALUE
    },
    {
      title: "Loại xác minh",
      dataIndex: "verify_mode",
      width: "8%",
      align: "center",
      render: verify_mode =>
        verify_mode ? verify_modes[verify_mode] : DEFAULT_VALUE
    },
    {
      title: "Thạng thái In/Out",
      dataIndex: "checkin_type",
      width: "8%",
      align: "center",
      render: checkin_type =>
        checkin_type ? checkin_types[checkin_type] : DEFAULT_VALUE
    },
    {
      title: "Trạng thái log",
      dataIndex: "sync_state",
      width: "10%",
      align: "center",
      render: sync_state =>
        sync_state !== null ? sync_states[sync_state] : DEFAULT_VALUE
    }
  ];
  const renderCardExtra = () => {
    return (
      <div className="d-flex aligns-items-center">
        <Button onClick={onClickRenew}>Làm mới</Button>
      </div>
    );
  };
  return (
    <Card
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số log: <Text className="text-dark">{total}</Text>
            </Text>
          </Col>
        </Row>
      }
      extra={renderCardExtra()}
    >
      <Table
        loading={{
          spinning: loading,
          delay: 500
        }}
        rowKey="_id"
        bordered
        size="small"
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: param.size,
          current: param.page,
          defaultPageSize: PAGINATION.page,
          total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
      />
    </Card>
  );
}

export default React.memo(TripodLogList);
